export default __webpack_public_path__ + "static/media/webilo-development.a8e99390.svg";